import { NavLink } from "react-router-dom";
import { FlaskConical, GraduationCap, BarChart3 } from "lucide-react";

const ITEMS = [["/robot-lab", "Robot Lab", FlaskConical], ["/advanced-courses", "Advanced Courses", GraduationCap], ["/my-progress", "My Progress", BarChart3]];

export const EduNav = () => (
  <nav className="inline-flex rounded-full bg-white/10 backdrop-blur-md border border-white/20 p-1" aria-label="Education" data-testid="edu-nav">
    {ITEMS.map(([to, label, Icon]) => (
      <NavLink key={to} to={to} data-testid={`edu-nav-${to.slice(1)}`}
        className={({ isActive }) => `inline-flex items-center gap-1.5 rounded-full px-3.5 sm:px-4 py-2 text-xs sm:text-sm font-bold transition-[background-color,color] duration-300 ${isActive ? "bg-white text-[#0A192F]" : "text-white/85 hover:text-white hover:bg-white/10"}`}>
        <Icon className="w-4 h-4" /><span className={to === "/my-progress" ? "hidden min-[430px]:inline" : ""}>{label}</span>
      </NavLink>))}
  </nav>
);
